import formatProjectApi from 'utils/format-project-api.js';

angular
.module('inkfinder')
.factory('Project', function Project(
  $http,
  ENDPOINT,
  FormatProject,
  Session,
  AlertMessages,
  _
) {
// Public methods
  Project.get = get;
  Project.getOptions = getOptions;
  Project.update = update;
  Project.create = create;

/**
 * @name get
 * @description Get a single project for collectors by passing
 * {type: 'collector', id: id}
 * @param {id} id The ID of the project to retrieve.
 * @return {object} data Returns the project object.
 */
  function get(id) {
    let role = Session.activeState.role;
    let associationId;
    if (!_.isUndefined(Session.activeState.association)) {
      associationId = Session.activeState.association.id;
    }
    return $http.get(ENDPOINT.server + 'projects/api/v1.1/' + id + '/' +
    '?role=' + role +
    (associationId ? ('&association_id=' + associationId) : ''))
    .then(function(response) {
      return FormatProject.format(response.data);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
  * @name getOptions
  * @description Function to get all options for size and area select boxes.
  * @return {unknown} data Returns the project options.
  */
  function getOptions() {
    return $http.get(ENDPOINT.server + 'projects/api/v1.1/area-location/')
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update a project
   * @param {object} project The project to update.
   * @return {object} data Returns the updated project.
   */
  function update(project) {
    let formattedProject = formatProjectApi(project);
    formattedProject.role = Session.activeState.role;
    if (!_.isUndefined(Session.activeState.association)) {
      formattedProject.association_id = Session.activeState.association.id;
    }
    return $http.put(ENDPOINT.server + 'projects/api/v1.1/' +
    project.id + '/', formattedProject)
    .then(function(response) {
      return FormatProject.format(response.data);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name create
   * @description Function to create a new project
   * @param {object} input The project data
   * @return {$http} Returns the $http service
   */
  function create(input) {
    // Move the location object inside the area object
    if (input.location) {
      input.area.location = input.location;
    }
    let project = formatProjectApi(input);
    project.role = Session.activeState.role;
    if (!_.isUndefined(Session.activeState.association)) {
      project.association_id = Session.activeState.association.id;
    }
    return $http.post(ENDPOINT.server + 'projects/api/v1.1/', project)
    .then(function(response) {
      return FormatProject.format(response.data);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return Project;
});



// WEBPACK FOOTER //
// ./components/projects/project/project.service.js